import React from 'react'
import ProgressBar from 'react-customizable-progressbar'

const Downloadbar = ({percentage}) => {


    const Indicator = (props) => {
        return (<>
        <div className="indicator-countdown"><div><div className={(props.progress > 0 && props.progress <=99) ? 'caption' : props.progress ==100?'captionComplete hide':'big'}>
        {props.progress <=0 ?"loading...":(props.progress > 0 && props.progress <=99)?"Downloading":props.progress==100?"Downloaded":""} </div><div className={props.progress > 0 ? 'time' : 'time hidden'}>
       {props.progress}%</div></div></div>
     <p style={{color:"white",fontSize:"10px",paddingLeft:"4px"}}>Downloading will depend on your internet speed</p>
        </>

        )
        }

  return (
    <>
     <div className="countdown"><ProgressBar
     radius={100}
     progress={percentage}
     strokeWidth={8}
     strokeColor="green"
     trackStrokeWidth={8}
     trackStrokeColor="#e6e6e6"
     pointerRadius={5}
     pointerFill="white"
     pointerStrokeWidth={8}
     pointerStrokeColor="indianred">
       <Indicator
     progress={percentage}
     elapsedSeconds={percentage}
     />
     </ProgressBar>
     </div>
    </>
  )
}

export default Downloadbar